// AUTO GENERATED FILE - DO NOT EDIT - GENERATED BY scripts/generate-permissions-type
export default {
	status: 'success',
	data: {
		resources: [
			{
				name: 'dashboard',
				type: 'metaresource',
			},
			{
				name: 'dashboards',
				type: 'metaresources',
			},
			{
				name: 'role',
				type: 'role',
			},
			{
				name: 'roles',
				type: 'metaresources',
			},
		],
		relations: {
			assignee: ['role'],
			create: ['metaresources'],
			delete: ['user', 'serviceaccount', 'role', 'organization', 'metaresource'],
			list: ['metaresources'],
			read: ['user', 'serviceaccount', 'role', 'organization', 'metaresource'],
			update: ['user', 'serviceaccount', 'role', 'organization', 'metaresource'],
		},
	},
} as const;
